import { Component, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwMessage, DwMessageSeverity } from '@devwareapps/devware-cap';
import IntegrationUtilService from '../../../integration/services/integration-util.service';

@DwComponent({
  key: 'aviatorLogin',
  name: 'Aviator Login Page',
  componentType: DwComponentType.pageComponent,
  isGlobal: true
})
@Component({
  selector: 'app-aviator-login-page',
  templateUrl: './aviator-login-page.component.html',
  styleUrls: ['./aviator-login-page.component.scss']
})
export class AviatorLoginPageComponent implements OnInit {

  topMessage: DwMessage;

  constructor(private integrationUtilService: IntegrationUtilService) { }

  ngOnInit(): void {

    const token = this.integrationUtilService.getIntegrationTokenDetails();

    if (token) {
      this.topMessage = {
        messageBody: 'Login or Sign up to complete FSP integration',
        severity: DwMessageSeverity.info,
      }
    }
  }
 
}
